

// $('#authLogin').validate({
// 	errorPlacement: function(error, element) {},
// 	rules: {
// 		username: 'required',
// 		password: 'required',
// 	}
// })

// $(document).ready(function () {
	if(($('#authLogin')).length) {
		require('./auth/login')
  }

  if(($('#authLogout')).length) {
		require('./auth/logout')
	}

	if(($('#authRegister')).length) {
		require('./auth/register')
	}
	if(($('#authRegisterVerify')).length) {
		require('./auth/register_verify')
	}
	if(($('#authRegisterUser')).length) {
		require('./auth/register_user')
	}

	if(($('#authRecovery')).length) {
		require('./auth/recovery')
	}
	if(($('#authRecoveryVerify')).length) {
		require('./auth/recovery_verify')
	}
	if(($('#authRecoveryUser')).length) {
		require('./auth/recovery_user')
	}
// })
